import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'YEARLY_BUDGET_EDIT';

export const showYearlyBudgetEdit = createAction(
  rootUiActions.createDialog.toString(),
  (budgetId, setHasAmountSaved, allCategoryIdsOfBudget, selectedMonthDate, annualBudgetDataOfCategory = {}, showCalculateAverageView = false, directlyCloseCalculateAverageView = false) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      annualBudgetDataOfCategory,
      budgetId,
      setHasAmountSaved,
      showCalculateAverageView,
      directlyCloseCalculateAverageView,
      allCategoryIdsOfBudget,
      selectedMonthDate,
    }),
  }),
);
